<div class="page-title">
  <div class="title" [innerHTML]="'SubstituteInfo.Single.Title' | translate | safe:'html'"></div>
  <div class="sub-title" [innerHTML]="'SubstituteInfo.Single.SubTitle' | translate | safe:'html'"></div>
</div>

<app-substitute
  [signatureModel]="user.signatureModel"
  [personalInfo]="user"
  [addressInfo]="user.addressModel"
  [citizenshipInfo]="user.contactModel"
  (userModelChange)="updateUser()"
>
</app-substitute>
